import ReviewsStateForPeriod from './ReviewsStateForPeriod';
import CompetitorReviewsState from '@app/model/review/state/CompetitorReviewsState';

export default class GroupReviewsStateForPeriod {
	monthPeriod: number | null;
	reviewsStates: ReviewsStateForPeriod[];

	constructor(data: GroupReviewsStateForPeriod) {

		this.monthPeriod = data.monthPeriod;
		this.reviewsStates = data.reviewsStates?.length ? data.reviewsStates.map(state => new ReviewsStateForPeriod(state)) : [];
	}

	public mainHotelStates(): CompetitorReviewsState[] {
		return this.reviewsStates
			.map(state => state.findMainHotelState())
			.filter((state): state is CompetitorReviewsState => !!state);
	}

	public findMainHotelStateByHotelId(hotelId: number): CompetitorReviewsState | undefined {
		return this.mainHotelStates().find(state => state.hotelId === hotelId);
	}

	public averageScore(): number {
		const states = this.mainHotelStates();
		const totalReviews = this.totalNumberOfReviews();

		if (totalReviews === 0) return 0;

		return states.reduce((sum, state) => {
			return sum + state.statistics.score * state.statistics.numberOfReviews;
		}, 0) / totalReviews;
	}

	public totalNumberOfReviews(): number {
		return this.mainHotelStates().reduce((sum, state) => sum + state.statistics.numberOfReviews, 0);
	}

	public averageResponseRate(): number {
		const states = this.mainHotelStates();
		const totalReviews = this.totalNumberOfReviews();

		if (totalReviews === 0) return 0;

		return states.reduce((sum, state) => {
			return sum + state.statistics.responseRate * state.statistics.numberOfReviews;
		}, 0) / totalReviews;
	}

	public averageRank(): number {
		const statesWithRank = this.reviewsStates.filter(state => state.rank > 0);

		if (statesWithRank.length === 0) return 0;

		return statesWithRank.reduce((sum, state) => sum + state.rank, 0) / statesWithRank.length;
	}

	public sentimentDistribution(): [number, number] {
		const states = this.mainHotelStates();
		const positiveSentiments = states.reduce((sum, state) => sum + state.statistics.positiveSentimentCount, 0);
		const negativeSentiments = states.reduce((sum, state) => sum + state.statistics.negativeSentimentCount, 0);
		const totalSentiments = positiveSentiments + negativeSentiments;

		if (totalSentiments === 0) return [0, 0];

		return [positiveSentiments / totalSentiments, negativeSentiments / totalSentiments];
	}
}
